import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getMenus } from '../../../../../../../redux/actions/menus'
import { IRootState } from '../../../../../../../redux/types'

export function useCreateInitialState(user: any, setCurrentTab: any) {
  const dispatch = useDispatch()
  const { menus } = useSelector((state: IRootState) => state.menu)

  useEffect(() => {
    if (menus.length === 0) dispatch(getMenus())
  }, [])

  useEffect(() => {
    if (user.role_id === 6) setCurrentTab(2)
    else setCurrentTab(0)
  }, [user.role_id])
}
